module.exports = __webpack_public_path__ + "static/assets/0be93d3ac2e32e0f83dd5610936ccd85.png";